import React, { useState } from 'react';
import { API } from '../utils/helpers';
import SpinboardMark from './SpinboardMark';

const colors = {
  bg: '#0f1623', card: '#1a2336', border: '#243050',
  text: '#e8e4dc', muted: '#5a6a8a', accent: '#F4622A', input: '#111827',
};

export default function ResetPassword({ token }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/users/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Reset failed'); return; }
      setSuccess(true);
    } catch (_) {
      setError('Connection error � please try again');
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: 6,
    border: `1px solid ${colors.border}`, background: colors.input,
    color: colors.text, fontSize: 14, boxSizing: 'border-box', outline: 'none',
  };

  const btnStyle = {
    width: '100%', padding: '11px', borderRadius: 6, border: 'none',
    background: colors.accent, color: '#fff', fontSize: 15,
    fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.7 : 1, marginTop: 4,
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: colors.bg,
      fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{
        width: 360, background: colors.card, borderRadius: 12,
        padding: '40px 36px', boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        border: `1px solid ${colors.border}`,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, background: '#243050', borderRadius: 12,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px',
          }}>
            <SpinboardMark size={36} />
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color: colors.accent, letterSpacing: '-0.5px', marginBottom: 4 }}>
            spinboard.
          </div>
        </div>

        {!success ? (
          <form onSubmit={handleSubmit}>
            <div style={{ fontSize: 15, fontWeight: 600, color: colors.text, marginBottom: 20 }}>
              Choose a new password
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, color: colors.muted, display: 'block', marginBottom: 6, letterSpacing: '0.06em', fontWeight: 600 }}>
                NEW PASSWORD
              </label>
              <input
                type="password"
                style={inputStyle}
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoFocus
              />
            </div>
            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 11, color: colors.muted, display: 'block', marginBottom: 6, letterSpacing: '0.06em', fontWeight: 600 }}>
                CONFIRM PASSWORD
              </label>
              <input
                type="password"
                style={inputStyle}
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
              />
            </div>
            {error && (
              <div style={{
                color: '#e74c3c', fontSize: 13, marginBottom: 14,
                textAlign: 'center', background: 'rgba(231,76,60,0.1)',
                padding: '8px 12px', borderRadius: 6,
              }}>
                {error}
              </div>
            )}
            <button type="submit" style={btnStyle} disabled={loading}>
              {loading ? 'Saving...' : 'Set New Password'}
            </button>
          </form>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
	      width: 48, height: 48, borderRadius: '50%', 
	      background: '#2ecc71',
	      margin: '0 auto 16px',
	      boxShadow: '0 0 0 8px rgba(46,204,113,0.15)'
            }} />
            <div style={{ fontSize: 15, color: colors.text, marginBottom: 8, fontWeight: 600 }}>
              Password updated!
            </div>
            <div style={{ fontSize: 13, color: colors.muted, marginBottom: 24 }}>
              You can now sign in with your new password.
            </div>
            <button
              onClick={() => window.location.href = '/'}
              style={btnStyle}
            >
              Go to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}